import { useTranslation } from 'react-i18next';
import { ExoUserGant } from '../exo/ExoUserGant';
import ModuleLayout from './ModuleLayout';
import { generateMediaQuerysForDashboardGridElement } from './dashboardGridManagement';
import { Box } from '@mui/material';

export const DashboardGant = ({ colSpan, rowSpan }) => {
  const { t } = useTranslation();
  const mediaQuerys = generateMediaQuerysForDashboardGridElement(
    colSpan,
    rowSpan
  );
  return (
    <Box sx={{ ...mediaQuerys }}>
      <ExoUserGant />
    </Box>
  );
};
